/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Ogdescriptionfallback2Inputs */

const ja_metadata_ogdescriptionfallback2 = /** @type {(inputs: Metadata_Ogdescriptionfallback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINは東京を拠点とするゲームマーケティング・eスポーツ制作会社です。ゲームパブリッシャー、デベロッパー、ゲーミングブランドの日本・アジア市場での成長はもちろん、欧米市場への展開も支援しています。マーケティング戦略、クリエイティブ制作、インフルエンサーマーケティング、eスポーツイベント・配信、デジタルプラットフォーム、ECソリューションまで一貫して提供。Riot Games、Ubisoft、Konami、Sony INZONE、Razerをはじめ、多くのゲーム業界を代表する企業から信頼をいただいています。`)
};

const en_metadata_ogdescriptionfallback2 = /** @type {(inputs: Metadata_Ogdescriptionfallback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN is a Tokyo-based game marketing agency helping publishers, developers, and gaming brands grow in Japan and Asia. We deliver end-to-end game marketing, esports production, influencer campaigns, creative services, digital platforms, and e-commerce solutions. Trusted by Riot Games, Ubisoft, Konami, Sony INZONE, Razer, and other leading gaming companies.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN is a Tokyo-based game marketing agency helping publishers, developers, and gaming brands grow in Japan and Asia. We deliver end-to-end game marketi..." |
*
* @param {Metadata_Ogdescriptionfallback2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_ogdescriptionfallback2 = /** @type {((inputs?: Metadata_Ogdescriptionfallback2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Ogdescriptionfallback2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_ogdescriptionfallback2(inputs)
	return en_metadata_ogdescriptionfallback2(inputs)
});
export { metadata_ogdescriptionfallback2 as "metadata_ogDescriptionFallback" }